module.exports = __webpack_public_path__ + "static/img/news3.a80eff8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/news/news3.png
// module id = 38uA
// module chunks = 11